import { render } from "./UserDataEdit.vue?vue&type=template&id=0ceed9f7"
import script from "./UserDataEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDataEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/start/UserDataEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ceed9f7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ceed9f7', __exports__)) {
    api.reload('0ceed9f7', __exports__)
  }
  
  module.hot.accept("./UserDataEdit.vue?vue&type=template&id=0ceed9f7", () => {
    api.rerender('0ceed9f7', render)
  })

}


export default __exports__